import { supabase } from '../supabase/client';

// Aggregierter Rechnungs-Import-Status je E-Mail, abgeleitet aus email_anhaenge.rechnung_status.
// 'rechnung' = als Rechnung erfasst, 'unklar' = im KI-Pool zur Prüfung, 'fehler' = Import
// fehlgeschlagen, 'duplikat' = derselbe Beleg ist bereits gebucht.
// 'duplikat' war bis 2026-08-11 ohne Anzeige — wer eine Rechnung erneut schickte, sah gar
// nichts und hielt sie für „nicht erkannt" (User-Meldung). 'keine' bleibt stumm: das ist ein
// Anhang, der schlicht keine Rechnung ist.
export type EmailRechnungBadge = 'rechnung' | 'unklar' | 'fehler' | 'duplikat';

const RANG: Record<EmailRechnungBadge, number> = { rechnung: 4, unklar: 3, duplikat: 2, fehler: 1 };

export async function ladeRechnungStatusFuerEmails(
  emailIds: string[],
): Promise<Record<string, EmailRechnungBadge>> {
  if (emailIds.length === 0) return {};

  // In Batches abfragen: .in() mit sehr vielen UUIDs erzeugt eine zu lange GET-URL
  // (bei ~876 Mails ~35 KB -> 414 URI Too Long -> Request scheitert). 100 pro Batch bleibt sicher.
  const CHUNK = 100;
  const batches: string[][] = [];
  for (let i = 0; i < emailIds.length; i += CHUNK) batches.push(emailIds.slice(i, i + CHUNK));

  const results = await Promise.all(
    batches.map((b) =>
      supabase.from('email_anhaenge').select('email_id, rechnung_status').in('email_id', b),
    ),
  );

  const map: Record<string, EmailRechnungBadge> = {};
  for (const { data, error } of results) {
    if (error) {
      console.error('Rechnungs-Status laden fehlgeschlagen', error.message);
      continue;
    }
    for (const r of data || []) {
      const s = (r as any).rechnung_status as string;
      if (s !== 'rechnung' && s !== 'unklar' && s !== 'fehler' && s !== 'duplikat') continue;
      const eid = (r as any).email_id as string;
      const cur = map[eid];
      // pro Mail den „höchsten" Status behalten (mehrere Anhänge möglich)
      if (!cur || RANG[s as EmailRechnungBadge] > RANG[cur]) map[eid] = s as EmailRechnungBadge;
    }
  }
  return map;
}
